/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller } from "@hotwired/stimulus";

export default class SearchController extends Controller<HTMLFormElement> {
	static targets = ["input", "datalist"];

	declare inputTarget: HTMLInputElement;
	declare datalistTarget: HTMLDataListElement;
	public abort_controller: AbortController | null = null;

	connect() {
		this.inputTarget.addEventListener("input", this.handleInput);
	}

	addOption(text: string) {
		const option = document.createElement("option");
		option.textContent = text;
		this.datalistTarget.appendChild(option);
	}

	abort() {
		this.abort_controller.abort();
		this.abort_controller = null;
	}

	async getSuggestions(): Promise<string[]> {
		if (this.abort_controller) {
			this.abort();
		}
		this.abort_controller = new AbortController();
		const term = this.inputTarget.value.trim().slice(0, 20);
		if (!term) {
			return [];
		}
		const response = await fetch(`/api/suggest/?term=${term}`, {
			signal: this.abort_controller.signal,
		});
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return response.json() as unknown as string[];
	}

	async refreshSuggestions() {
		let suggestions: string[] = [];
		try {
			suggestions = await this.getSuggestions();
		} catch (e) {
			return;
		}
		this.datalistTarget.replaceChildren();
		for (const s of suggestions) {
			this.addOption(s);
		}
	}

	handleInput = (e: InputEvent) => {
		if (e.inputType == "insertReplacementText") {
			this.element.requestSubmit();
		} else {
			void this.refreshSuggestions();
		}
	};

	disconnect() {
		this.inputTarget.removeEventListener("input", this.handleInput);
	}
}
